import { assertValue } from '@/lib/env';

export const useCdn = false;

/**
 * Import Algolia environment variables from .env.local
 */

export const applicationId = assertValue(
  process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID,
  'Missing environment variable: NEXT_PUBLIC_ALGOLIA_APPLICATION_ID'
);

export const index = assertValue(
  process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME,
  'Missing environment variable: NEXT_PUBLIC_ALGOLIA_INDEX_NAME'
);

export const readToken = assertValue(
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY,
  'Missing environment variable: NEXT_PUBLIC_ALGOLIA_SEARCH_KEY'
);

// NOTE: The Algolia admin (write) key is a server-only secret and lives in
// `lib/algolia/server.env.ts`. It must never be imported into client code —
// keeping it out of this (client-importable) module ensures Next.js never
// inlines it into the browser bundle.
